export default function PHP_Inheritance() {
  return (
    <div>
      <h1>PHP_Inheritance</h1>
    </div>
  );
}
